import React, { useEffect, useState, useTransition } from 'react';
import classes from './HomePage2.module.css';
import { upcomingMatchesApi, userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import Header2 from '../../component/NewComponents/Header2';
import MatchLayoutNew from '../../component/NewComponents/MatchLayoutNew';
import { useTranslation } from 'react-i18next';

const HomePage2 = () => {
  const [upcomingMatches, setUpcomingMatches]         = useState([]);
  const [userMatches, setUserMatches]                 = useState(null);
  const [userMatchesLoading, setUserMatchesLoading]   = useState(true);
  const [loading, setLoading]                         = useState(true);
  const [loader, setLoader]                           = useState(true);

  const { userDetails } = useSelector(state => state.persisted?.userSlice);
  const navigate        = useNavigate();
  const dispatch        = useDispatch();

  const {t}=useTranslation();

  /* ─── API calls ─── */
  const fetchUserMatches = async (load) => {
    try {
      if (load) setUserMatchesLoading(true);
      setLoader(true);
      const response = await userMatchesApi(userDetails?.token);
      setUserMatches({
        fantasy:    response?.data?.fantasy,
        prediction: response?.data?.prediction,
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.data?.message ||
        t("2")
      );
    } finally {
      setUserMatchesLoading(false);
      setLoader(false);
    }
  };

  const fetchUpcomingMatches = async (load) => {
    try {
      if (load) setLoading(true);
      setLoader(true);
      const response = await upcomingMatchesApi(userDetails?.token);
      setUpcomingMatches(response?.data);
    } catch (error) {
      if (error?.response?.status === 403) {
        dispatch(removeUserDetails());
        toast.error(t("71"));
        navigate('/');
      } else {
        toast.error(
          error?.response?.data?.message ||
          error?.response?.message ||
          error?.data?.message ||
          t("2")
        );
      }
    } finally {
      setLoading(false);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchUserMatches(true);
    fetchUpcomingMatches(true);
  }, []);

  /* Auto-refresh every 10 s when tab is visible */
  useEffect(() => {
    if (!loader) {
      const id = setInterval(() => {
        if (!document.hidden) {
          fetchUserMatches();
          fetchUpcomingMatches();
        }
      }, 10000);
      return () => clearInterval(id);
    }
  }, [loader]);

  const isLoading = loading || userMatchesLoading;

  return (
    <>
      <Header2 active={0} />

    <div className={classes.page}>

      {/* Background effects */}
      <div className={classes.bgGlow} />
      <div className={classes.bgGrid} />

      {/* Top header (logo bar) + Bottom nav injected by Header2 */}

      <main className={classes.main}>

        {/* ── Hero bar ── */}
        <div className={classes.heroBar}>
          <div className={classes.heroLeft}>
            <span className={classes.heroEyebrow}>{t("72")}</span>
            <h1 className={classes.heroTitle}>
              {t("73")} <em>{t("74")}</em>
            </h1>
          </div>
          <div className={classes.heroRight}>
            <div className={classes.heroCountBadge}>
              <span className={classes.heroCountNum}>{upcomingMatches.length}</span>
              <span className={classes.heroCountLabel}>{t("75")}</span>
            </div>
            <div className={classes.liveTag}>
              <span className={classes.liveDot} />
              {t("76")}
            </div>
          </div>
        </div>

        {/* ── Divider ── */}
        <div className={classes.divider} />

        {/* ── Content ── */}
        {isLoading ? (
          <div className={classes.loaderWrap}>
            <SmallLoader style={{ border: "4px solid #e60000", borderTopColor: "transparent" }} />
            <p className={classes.loaderText}>{t("77")}</p>
          </div>
        ) : (
          <div className={classes.matchGrid}>
            {upcomingMatches.length > 0 ? (
              upcomingMatches.map((match, index) => (
                <MatchLayoutNew
                  key={index}
                  match={match}
                  index={index}
                  fantasy_match_joined={
                    userMatches?.fantasy?.filter(
                      d => d?.match_fixture_id === match?.match_fixture_id
                    ).length > 0
                  }
                  prediction_match_joined={
                    userMatches?.prediction?.filter(
                      d => d?.match_fixture_id === match?.match_fixture_id
                    ).length > 0
                  }
                />
              ))
            ) : (
              <div className={classes.emptyState}>
                <span className={classes.emptyEmoji}>⚽</span>
                <p className={classes.emptyTitle}>{t("78")}</p>
                <p className={classes.emptySub}>{t("79")}</p>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
    </>

  );
};

export default HomePage2;